<template>
  <div>
    <v-row dense>
      <v-col>
        <a
          href="https://www.nttdocomo.co.jp/area/servicearea/?rgcd=03&amp;cmcd=LTE&amp;scale=128000&amp;lat=35.686254&amp;lot=139.694936"
          target="_blank"
          >サービスエリアマップ | 通信・エリア | NTTドコモ</a
        >
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <a
          href="http://www13.info-mapping.com/au/map/index.aspx?maptype=5g&amp;l=35.6939457%2c139.7011918&amp;z=6"
          target="_blank"
          >サービスエリアマップ | エリア：スマートフォン・携帯電話 | au</a
        >
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <a
          href="https://www.softbank.jp/mobile/network/area/map/"
          target="_blank"
          >サービスエリアマップ | スマートフォン・携帯電話 | ソフトバンク</a
        >
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <a href="https://network.mobile.rakuten.co.jp/area/" target="_blank"
          >通信・エリア | 楽天モバイル</a
        >
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <a href="https://www.uqwimax.jp/wimax/area/pref/tokyo/" target="_blank"
          >エリアマップ | UQ コミュニケーションズ</a
        >
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <a
          href="https://www.ymobile.jp/area/#usim"
          target="_blank"
          >エリアマップ｜エリア｜Y!mobile - 格安SIM・スマホはワイモバイルで</a
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "MobileAreaLink",
};
</script>
